import React from 'react';
import { AutoComplete } from 'antd';
import { AutoCompleteProps } from 'antd/lib/auto-complete';
import './AutoComplete.less';

const TAutoComplete: React.FC<
  AutoCompleteProps & { useDefaultWrapper: boolean }
> = ({ useDefaultWrapper, ...props }) => {
  const wrapperProp = !useDefaultWrapper
    ? { getPopupContainer: (trigger) => trigger.parentNode }
    : '';
  return (
    <AutoComplete
      {...props}
      {...wrapperProp}
      getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
    />
  );
};

export default TAutoComplete;
